import React from 'react';

export default function IntroVideo() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex flex-col justify-center items-center text-white">
      <h1 className="text-4xl font-extrabold mb-8">🎥 Welcome to NubbiLand</h1>
      <div className="w-full max-w-3xl px-4">
        <video controls className="w-full rounded-xl shadow-lg">
          <source src="/intro.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}